import { ScrollSaver } from "./ScrollSaver";
import { createMessageHandler } from "./createMessageHandler";

export const initializeScrollSaver = (currentPath: string) => {
    const scrollSaver = new ScrollSaver(currentPath);
    window.addEventListener("message", createMessageHandler(scrollSaver), false);
};
